import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ss-inline-confirm',
  templateUrl: './inline-confirm.component.html',
  styleUrls: ['./inline-confirm.component.scss'],
  standalone: false
})
export class InlineConfirmComponent implements OnChanges {
  @Input() open = false;
  @Input() tone: 'danger' | 'warning' | 'info' = 'danger';
  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = 'Confirmar';
  @Input() cancelLabel = 'Cancelar';
  @Input() loading = false;
  /** `inline` é o banner no fluxo da página; `modal` abre um diálogo bloqueante, para ações críticas. */
  @Input() variant: 'inline' | 'modal' = 'modal';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open) {
      if (this.variant === 'modal') return;
      setTimeout(() => {
        const host = this.elementRef.nativeElement;
        host.querySelector<HTMLButtonElement>('[data-cancel]')?.focus();
        host.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      });
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open && !this.loading && this.variant === 'inline') {
      this.cancelled.emit();
    }
  }

  confirm(): void {
    if (!this.loading) {
      this.confirmed.emit();
    }
  }
}
